import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BatteryCharging02 = function BatteryCharging02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9.5 18 4-6h-6l4-6M22 13v-2m-8 7h.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2V10c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C16.395 6 15.93 6 15 6M7 6h-.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C4.605 18 5.07 18 6 18"
    })
  }));
};
export default BatteryCharging02;